<script>
import BaseAutocompleteFilter from '@/modules/_global/_components/filters/BaseAutocompleteFilter';
import { VERWALTUNG } from '@/modules/companies/common/companyTypes';
import { mapCacheActions } from 'vuex-cache';
export default {
  name: 'ManagementCompanyFilter',

  extends: BaseAutocompleteFilter,

  methods: {
    ...mapCacheActions('company', ['retrieveCompaniesByType']),

    getData() {
      return this.retrieveCompaniesByType(VERWALTUNG).then(({ data }) => {
        return data;
      });
    }
  }
};
</script>
